
import { useCustomLayout } from "./intermark/intermarkHook";
import { IntermarkLogo } from "./intermark/IntermarkLogo";
import { Avatar, Typography } from "@mui/material";

export const HeaderLogo = () => {
  const isCustom = useCustomLayout();

  if (isCustom) {
    return <IntermarkLogo />;
  }

  return (
    <>
      <Avatar
        sx={{
          bgcolor: 'primary.main',
          color: 'header',
          fontSize: '34px',
          fontWeight: 700
        }}
      >
        A
      </Avatar>
      <Typography
        sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
        color="primary"
        ml={2}
        variant="h3"
      >
        Apparts ЛК
      </Typography>
    </>
  );
};